import { Link } from "react-router-dom";
import { ArrowRight, Mail } from "lucide-react";
import { SEO, SITE_URL } from "@/components/SEO";
import { Reveal } from "@/components/Section";
import { ISSUES } from "@/lib/newsletterData";

export default function NewsletterHub() {
  return (
    <div className="min-h-screen bg-black text-white" data-testid="newsletter-hub-page">
      <SEO
        title="The WearSpray Newsletter: Personalization and Immediate Action"
        description="Notes from WearSpray's founder on personalization, wearable intelligence, and closing the gap between skincare guidance and immediate action."
        path="/newsletter"
        image={`${SITE_URL}/og/wearspray-newsletter-personalization.jpg`}
      />

      <section className="max-w-4xl mx-auto px-6 md:px-10 pt-36 md:pt-44 pb-16 md:pb-20">
        <Reveal>
          <span className="font-mono text-xs tracking-[0.25em] uppercase text-accent flex items-center gap-2">
            <Mail size={13} /> WearSpray Newsletter
          </span>
          <h1 className="font-heading text-4xl sm:text-5xl lg:text-6xl font-light tracking-tight leading-[1.05] mt-5 text-white">
            Notes on personalization<br />and immediate action.
          </h1>
          <p className="font-body text-zinc-400 text-lg leading-relaxed mt-6 max-w-2xl">
            Occasional long-form notes from our founder on where skincare intelligence, wearable
            technology, and everyday behavior intersect, and how WearSpray is building the bridge
            between guidance and action.
          </p>
        </Reveal>
      </section>

      <section className="max-w-4xl mx-auto px-6 md:px-10 pb-28 md:pb-36">
        <div className="space-y-6" data-testid="newsletter-issue-list">
          {ISSUES.map((issue, i) => (
            <Reveal key={issue.slug} delay={i * 0.06}>
              <Link
                to={`/newsletter/${issue.slug}`}
                data-testid={`newsletter-issue-card-${issue.slug}`}
                className="group block border border-zinc-800 rounded-2xl p-7 md:p-9 hover:border-accent/50 transition-colors"
              >
                <span className="font-mono text-[11px] tracking-[0.15em] uppercase text-zinc-500">{issue.date}</span>
                <h2 className="font-heading text-2xl md:text-3xl font-medium tracking-tight text-white mt-3 group-hover:text-accent transition-colors">
                  {issue.title}
                </h2>
                <p className="font-body text-zinc-400 leading-relaxed mt-4 max-w-2xl">{issue.excerpt}</p>
                <span className="inline-flex items-center gap-1.5 font-body text-sm font-medium text-accent mt-5">
                  Read the issue <ArrowRight size={14} className="group-hover:translate-x-1 transition-transform" />
                </span>
              </Link>
            </Reveal>
          ))}
        </div>
      </section>
    </div>
  );
}
